module.exports = __webpack_public_path__ + "media/images/result_sets/icons/easy_icon-15dbb9133bd8235199d01befa4632e34.svg";